import React from 'react';

export const StatStrip = ({ title, subtitle, stats, testid }) => (
  <div className="op-card-dark relative overflow-hidden p-5 sm:p-6 op-rise" data-testid={testid}>
    <div className="absolute -right-20 -top-24 w-72 h-72 rounded-full bg-[#F26B1F]/20 blur-3xl" />
    <div className="relative">
      <p className="op-label !text-white/45">{subtitle}</p>
      <p className="mt-1 text-lg font-semibold">{title}</p>
      <div className="mt-4 grid grid-cols-2 lg:grid-cols-4 gap-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl bg-white/[0.05] border border-white/[0.06] p-3.5">
            <p className="text-[11px] text-white/55">{s.label}</p>
            <p className={`mt-1 text-xl sm:text-2xl font-bold op-num ${s.accent ? 'text-[#FF8A4C]' : ''}`}>{s.value}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);
